import React, { memo, useCallback } from "react";
import { Heading, Button } from "../../components";

const NotFoundErrorComponent = ({
  bodyClass,
  flexBodyClass,
  view,
  workflowID,
  matchId,
  navigate,
}) => {
  const id = !view ? matchId : workflowID;
  const handleNavigation = useCallback(() => {
    navigate(`/search`, { replace: true });
  }, [navigate]);

  return (
    <div className={`${bodyClass} ${flexBodyClass}`}>
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Heading level={1} gutterBottom>
          Workflow Not Found
        </Heading>
        <Heading level={-1} style={{ marginBottom: "20px", color: "#666" }}>
          No workflow found with ID: {id}
        </Heading>
        <p style={{ marginBottom: "30px", color: "#888" }}>
          The workflow you're looking for doesn't exist or may have been
          deleted.
        </p>
        {!view ? (
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleNavigation();
            }}
          >
            Go to Search
          </Button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

// Apply memo and set displayName for better debugging
const NotFoundError = memo(NotFoundErrorComponent);
NotFoundError.displayName = "NotFoundError";

export default NotFoundError;
